const permissionRouter = [
    {
        path: "list-group",
        name: "permission",
        component: () => import("@/views/admin/permission"),
        default: true,
        meta: {
            model: "group",
            // requiresAuth: true,
        },
    },
    {
        path: "list-group/add",
        name: "addPermission",
        component: () => import("@/views/admin/permission/function"),
        default: true,
        meta: {
            model: "group",
            // requiresAuth: true,
        },
    },
    {
        path: "list-group/edit/:id",
        name: "editPermission",
        component: () => import("@/views/admin/permission/function"),
        default: true,
        meta: {
            model: "group",
            // requiresAuth: true,
        },
    },
    {
        path: "list-group/users",
        name: "groupUser",
        component: () => import("@/views/admin/permission/users/index"),
        default: true,
        meta: {
            model: "group_user",
            // requiresAuth: true,
        },
        props: route => ({ group_id: route.query.group })
    },
    {
        path: "list-group/users/add",
        name: "addGroupUser",
        component: () => import("@/views/admin/permission/users/function"),
        default: true,
        meta: {
            model: "group_user",
            // requiresAuth: true,
        },
        props: route => ({ group_id: route.query.group })
    },
];
export default permissionRouter;